import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
  standalone: false,
  selector: 'progress-spinner',
  templateUrl: './progress-spinner.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './progress-spinner.component.scss'
})
export class ProgressSpinnerComponent {

  @Input() loaderMessage:string="In-Progress";

}
